import { IconStar } from '@madpaws/design-system';
import getConfig from 'next/config';
import React from 'react';

import styles from './ProductReview.module.css';

import type { ReactElement } from 'react';

const { publicRuntimeConfig } = getConfig();

export const ProductReview = (): ReactElement => (
  <div className={styles.root}>
    <div className={styles.review}>
      <p className={styles.rate}>4.6</p>
      <IconStar />
    </div>
    <p>from over 3000 reviews on</p>
    <img
      alt="Product Review"
      height={24}
      src={`${publicRuntimeConfig.staticPath}/images/homepage/product-review-logo.svg`}
      width={139}
    />
    <div className={styles.winner}>
      <p>🏆 2025 Award Winner</p>
    </div>
  </div>
);
